export const logError = (context: string, error: any): void => {
  console.error(`Error in: ${context}`);

  if (error?.message) console.error(error.message);
  if (error?.stack) console.error(error.stack);

  if (error?.response) {
    console.error(error.response.status);
    console.error(error.response.data);
  }

  if (error?.config) {
    console.error(error.config.url);
    console.error(error.config.method);
    console.error(error.config.headers);
    console.error(error.config.data);
  }

  if (!error?.message && !error?.response && !error?.config) {
    console.error(error);
  }
};
